<template>
  <div
    class="container"
    id="inform"
    :style="{
      background:
        'url(' +
        require('../../assets/img/' + bei_ing) +
        ') no-repeat center center',
      'background-size': '100% 100%',
    }"
  >
    <!-- <div class="yindaoru" v-if="ziliao" @click="ziliaos">
      <div class="qian">填写您的资料</div>
      <video
        src="../../assets/tian.mp4"
        class="videp"
        autoplay="true"
        loop="true"
        muted="“muted”"
      ></video>
    </div>
    <div class="yindaoru" v-if="fabu" @click="fabuyin">
      <div class="qian">点击可前往选择您的课程内容</div>
      <video
        src="../../assets/kechen.mp4"
        class="videp"
        autoplay="true"
        loop="true"
        muted="“muted”"
      ></video>
    </div> -->

    <!-- <div class="zijikios" v-if="kao" @click="kaos"></div> -->
    <!-- <div class="zijikiox" v-if="xua" @click="xuax"></div> -->
    <!-- <div class="zijikiokai" v-if="kaiv" @click="kaio"></div> -->
    <dingbu
      @searchClick="searchClick"
      @addservere="addservere"
      @paget="paget"
      @cart-tatus="cartTatus"
    ></dingbu>
    <div class="home_content">
      <div class="bg_color">
        <div class="w">
          <div class="inform__box">
            <div class="box__top">
              <span class="shou__ye">首页</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <router-link tag="span" class="ton__zhi2" to="/learn"
                >学习系统</router-link
              >
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi">{{ msg }}</span>
            </div>
          </div>
          <div class="box-contentk">
            <div class="box-lok">
              <div
                class="box-list"
                v-for="(item, index) in addki"
                :key="index"
                :data-index="index"
                :class="orderindex == index ? 'orderactivegd' : ''"
                @click="selorder"
              >
                <img class="ziliao" :src="item.url" alt />
                <div class="ziliao-text">{{ item.text }}</div>
              </div>
            </div>
            <!-- 我的资料 -->
            <div class="box-ziliao" v-if="orderindex == 0">
              <div class="wode">我的资料</div>
              <div class="gexiang-l"></div>
              <div class="wode-list">
                <div class="wode-l-name">姓名</div>
                <div class="wode-my">{{ usergo.nickname }}</div>
              </div>
              <div class="wode-list">
                <div class="wode-l-name">性别</div>
                <el-select v-model="value" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="wode-list">
                <div class="wode-l-name">身份证号码</div>
                <div class="wode-my">{{ usergo.card }}</div>
              </div>
              <div class="wode-list">
                <div class="wode-l-name">工作单位</div>
                <div class="wode-my">{{ usergo.work_address }}</div>
              </div>
              <div class="wode-listo">
                <div class="wode-phong">
                  <div class="wode-l-name">手机号码</div>
                  <div class="wode-my">
                    <input
                      class="ipd"
                      maxlength="11"
                      oninput="if(value.length>11)value=value.slice(0,11)"
                      type="text"
                      v-model="phonet"
                      placeholder="请输入手机号"
                    />
                  </div>
                </div>
                <div class="yangzhen-ma">
                  <div class="ma">验证码：</div>
                  <div class="ipf">
                    <input
                      class="ipk"
                      @blur="animateWidth"
                      type="text"
                      v-model="codet"
                      placeholder="请输入验证码"
                    />
                  </div>
                  <div class="huoqu-ma" @click="semat">{{ content }}</div>
                </div>
              </div>
              <div class="shanchuan">
                <div class="shan-c">上传照片</div>
                <!-- <img class="tupian" :src="innerimg" alt @click="shanchuan" /> -->
                <!-- element 上传图片按钮 -->
                <div
                  class="tukimg"
                  v-if="
                    headimg != '//enterprise.t.brotop.cn/uploads/mo.png'
                  "
                >
                  <img
                    :src="headimg"
                    alt
                    v-if="
                      headimg != '//enterprise.t.brotop.cn/uploads/mo.png'
                    "
                    class="tuk"
                    style="marginleft: 30px"
                  />
                </div>

                <el-upload
                  v-else
                  class="tupian"
                  action
                  drag
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change="changeUpload"
                >
                  <!-- <img class="tuk" src="../../assets/upimg.png" alt /> -->
                  <div class="tukimg">
                    <img class="tuk" src="../../assets/me.png" alt />
                  </div>

                  <!-- <i class="el-icon-upload"></i> -->
                  <!-- <div class="el-upload__text">点击上传</div> -->
                  <!-- <div class="el-upload__tip">
              支持绝大多数图片格式，单张图片最大支持5MB
            </div>-->
                </el-upload>
                <div class="tishi">
                  <div class="wenxin">温馨提示：</div>
                  <div class="tishi-text">
                    1、本页填写的信息仅用于发放考试合格证，请填写真实数据及本人照片。
                    <br />2、照片请上传1寸照片
                    <br />3、照片仅可以上传一次，后续如需修改，请联系客服修改，
                    <br />
                  </div>
                </div>
              </div>
              <div class="dibu-btnlp">
                <div class="btn-quxiao">取消</div>
                <div class="btn-baocun" @click="baocunm">保存</div>
              </div>
            </div>
            <!-- 课程列表 -->
            <div class="box-ziliaolk" v-if="orderindex == 1">
              <div class="wode">课程列表</div>
              <div class="gexiang-l"></div>

              <div class="box-tou">
                <div class="tabbar-tolp">
                  <div
                    v-for="(items, index) in adto"
                    :key="index"
                    :data-index="index"
                    :class="orderindexh == index ? 'orderactiveh' : ''"
                    @click="selorderh"
                    :data-id="items.id"
                  >
                    {{ items.text }}
                  </div>
                </div>
                <div class="kengit" v-if="orderindexh == 0">
                  <div
                    class="kecheng-xiu"
                    v-for="(item, index) in addlik"
                    :key="index"
                    @click="xianqing(item.id)"
                  >
                    <div class="bixiu-img">
                      <div class="bixiu-xuanxiu">{{ item.elective }}</div>
                      <div class="bixiu-niandu">{{ item.tag }}</div>
                      <img :src="item.video_image" alt />
                    </div>
                    <div class="bixiu-title">
                      <div class="bixiu-text">{{ item.name }}</div>
                      <div class="keshi-tim">
                        <div class="keshi-duo">{{ item.class_hour }}课时</div>
                        <div class="keshi-rig">
                          <div class="keshi-name">讲师：</div>
                          <div class="keshi-ming">{{ item.teacher }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="fenye">
                    <el-pagination
                      background
                      @prev-click="prev"
                      @next-click="next"
                      @current-change="current"
                      :current-page="addkil"
                      :page-size="pageNum"
                      layout="prev, pager, next, jumper"
                      :total="total"
                    ></el-pagination>

                    <!-- 
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="pageNum"
                :current-page="addkil"
                @prev-click="prev"
                @next-click="next"
                @current-change="current"
              ></el-pagination>
              -->
                  </div>
                </div>
                <div class="kengit" v-if="orderindexh == 1">
                  <div
                    tag="div"
                    class="kecheng-xiu"
                    v-for="(item, index) in addlik"
                    :key="index"
                    @click="xianqing(item.id)"
                  >
                    <div class="bixiu-img">
                      <div class="bixiu-xuanxiu">{{ item.elective }}</div>
                      <div class="bixiu-niandu">{{ item.tag }}</div>
                      <img :src="item.video_image" alt />
                    </div>
                    <div class="bixiu-title">
                      <div class="bixiu-text">{{ item.name }}</div>
                      <div class="keshi-tim">
                        <div class="keshi-duo">{{ item.class_hour }}课时</div>
                        <div class="keshi-rig">
                          <div class="keshi-name">讲师：</div>
                          <div class="keshi-ming">{{ item.teacher }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="fenye">
                    <el-pagination
                      background
                      layout="prev, pager, next, jumper"
                      :total="total"
                      :page-size="pageNum"
                      :current-page="addkil"
                      @prev-click="prev"
                      @next-click="next"
                      @current-change="current"
                    ></el-pagination>
                  </div>
                </div>
                <div class="kengit" v-if="orderindexh == 2">
                  <div
                    tag="div"
                    class="kecheng-xiu"
                    v-for="(item, index) in addlik"
                    :key="index"
                    @click="xianqing(item.id)"
                  >
                    <div class="bixiu-img">
                      <div class="bixiu-xuanxiu">{{ item.elective }}</div>
                      <div class="bixiu-niandu">{{ item.tag }}</div>
                      <img :src="item.video_image" alt />
                    </div>
                    <div class="bixiu-title">
                      <div class="bixiu-text">{{ item.name }}</div>
                      <div class="keshi-tim">
                        <div class="keshi-duo">{{ item.class_hour }}课时</div>
                        <div class="keshi-rig">
                          <div class="keshi-name">讲师：</div>
                          <div class="keshi-ming">{{ item.teacher }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="fenye">
                    <el-pagination
                      background
                      layout="prev, pager, next, jumper"
                      :total="total"
                      :page-size="pageNum"
                      :current-page="addkil"
                      @prev-click="prev"
                      @next-click="next"
                      @current-change="current"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </div>
            <!-- 我的考试 -->
            <div class="goncheng" v-if="orderindex == 2">
              <div class="gon-top">
                <img class="tu" :src="examine.image" alt />
                <div class="xianqin">
                  <div class="qianqin-title">{{ examine.examname }}</div>
                  <div class="jiezhi">
                    考试截止时间：{{ examine.expirationtime }}
                  </div>
                  <div class="suoxu">
                    <div class="suoxu-keshi">
                      所需课时：{{ examine.class_hour }}
                    </div>
                    <div class="suoxu-yiwan">
                      已完成课时：{{ examine.finish_hour }}
                    </div>
                  </div>
                  {{ examine.num }}
                  <div class="jindu-tiao">
                    <div
                      class="neijindu"
                      v-bind:style="{ width: examine.proportion }"
                    ></div>

                    <div
                      class="jindu-shichan"
                      v-bind:style="{ left: examine.proportion }"
                    >
                      <img
                        class="jindu-jian"
                        src="../../assets/biaozhu_img@2x.png"
                        alt
                      />
                      <div class="jindu-shu">{{ examine.proportion }}</div>
                    </div>
                  </div>
                </div>
                <div class="kaishi">
                  <div class="quxuan" @click="xuanke">去选课</div>
                  <div
                    class="kaishi-kaoh"
                    @click="kaishi"
                    v-if="examine.is_xian == 1"
                  >
                    开始考试
                  </div>
                  <div class="kaishi-kaohv" v-if="examine.is_xian == 2">
                    开始考试
                  </div>
                </div>
              </div>
              <div class="gon-wenxin">
                <div class="wen-ti">温馨提示：</div>
                <div class="wen-list">
                  1、课程到达截止日期后将会自动下架，请在有效期内完成视频学习。
                  <br />2、只有当课程学习进度在100%后，方可获得该课程的课时。
                  <br />3、课程可重复学习，但是不会累计课时。
                  <br />4、学员必须完成所有必修课，且修够所有的课时后方可参加考试。每期学习最多可参加3次考试。
                  <br />
                </div>
              </div>
              <div class="biaodan">
                <div class="biao-tou">
                  <div class="biao-name">课程名称</div>
                  <div class="biao-xue">学时</div>
                  <div class="biao-xue">必修/选修</div>
                  <div class="biao-xue">时长（分钟）</div>
                  <div class="biao-xue">学习进度</div>
                  <div class="biao-xue">状态</div>
                  <div class="biao-xuel">操作</div>
                </div>
                <div
                  class="biao-list"
                  v-for="(item, index) in examin"
                  :key="index"
                >
                  <div class="list-name">{{ item.name }}</div>
                  <div class="list-xue">{{ item.class_hour }}</div>
                  <div class="list-xue">{{ item.mtok }}</div>
                  <div class="list-xue">{{ item.duration }}</div>
                  <div class="list-xuec">
                    <div class="jindu">
                      <div class="nei-jindu" :style="{ width: item.nom }">
                        {{ item.proportion }}
                      </div>
                    </div>
                  </div>
                  <div class="list-xue">{{ item.msgto }}</div>
                  <div class="list-xuel">
                    <div class="jixu-l" @click="jixuxuexi(item.id)">
                      继续学习
                    </div>
                    <div class="ge" v-if="item.mlk"></div>
                    <div
                      class="yichu"
                      :plain="true"
                      v-if="item.mlk"
                      @click="yichu(item.id)"
                    >
                      移除
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 考试记录 -->
            <div class="kaoshi-jilu kaoshi__jilu" v-if="orderindex == 3">
              <div class="mon_th">
                <el-date-picker
                  v-model="valueDate"
                  @change="getpickerDate"
                  type="month"
                >
                </el-date-picker>
              </div>
              <div class="kaoshi-top">
                <div>考试名称</div>
                <div>第一次考试</div>
                <div>第二次考试</div>
                <div>第三次考试</div>
              </div>
              <div class="kaoshi-list">
                <div class="kaoshi-name">{{ studtk.examname }}</div>

                <div
                  class="kaoshi-one"
                  v-for="(item, index) in recordo"
                  :key="index"
                >
                  <div class="one-time">考试时间：{{ item.createtime }}</div>
                  <div class="one-time">考试成绩：{{ item.score }}</div>
                  <div class="one-cha" @click="cha(item.id)" v-if="item.cladk">
                    查看证书
                  </div>
                </div>
                <div class="kaoshi-one" v-if="recordo.length <= 0"></div>
                <div class="kaoshi-one" v-if="recordo.length <= 1"></div>
                <div class="kaoshi-one" v-if="recordo.length <= 2"></div>
              </div>
            </div>
            <!-- 修改密码 -->
            <div class="xiugai-mima" v-if="orderindex == 4">
              <img
                class="guanbi-xiugai"
                src="../../assets/guanbi_icon@2x (2).png"
                alt
                @click="guan"
              />
              <div class="gai-xiu">修改密码</div>
              <div class="heng-l"></div>
              <div class="zhanhao">
                <div class="zhanhao-name">账号:</div>
                <input
                  type="text"
                  class="zhaohang-inpu"
                  v-model="usnamo"
                  placeholder="请输入账号"
                />
              </div>
              <div class="zhanhaok">
                <div class="zhanhao-name">原密码:</div>
                <input
                  type="password"
                  class="zhaohang-inpu"
                  v-model="pawed"
                  placeholder="请输入原密码"
                />
              </div>
              <div class="zhanhaok">
                <div class="zhanhao-name">新密码:</div>
                <input
                  type="password"
                  class="zhaohang-inpu"
                  v-model="pawedlg"
                  placeholder="请输入新密码"
                />
              </div>
              <div class="zhanhaok">
                <div class="zhanhao-name">验证密码:</div>
                <input
                  type="password"
                  class="zhaohang-inpu"
                  v-model="pawedlk"
                  placeholder="请再次输入新密码"
                />
              </div>
              <div class="queding-btn" @click="xiugaipaw">确定修改</div>
            </div>
            <!-- 购买记录 -->
            <div class="purchase__history" v-if="orderindex == 5">
              <div class="histoy">
                <div class="data_date">2002-1-20</div>
                <div class="store__box">
                  <img src="../../assets/img/img_34.png" alt="" />
                  <div class="rig_box">
                    <div class="big_title_money">
                      <div class="big__title">安全拉萨解放了</div>
                      <div class="big__money">
                        <span class="money_name">购买金额：</span>
                        <span class="money_count">100元</span>
                      </div>
                    </div>
                    <div class="small_title_money">
                      <div class="small__title">安全拉萨解放了</div>
                      <div class="small__money">
                        <span class="icon_money_name">购买时间：</span>
                        <span class="icon_money_count">17:09:01</span>
                      </div>
                    </div>
                    <div class="down_text">
                      <div class="small__title">
                        <img src="../../assets/img/jin_10.png" alt="" />
                        <div class="start_time">
                          起止时间：2020/10/09-2021/10/09
                        </div>
                      </div>
                      <div class="kai__piao">申请开票</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- vueCropper 剪裁图片实现-->
          <el-dialog
            title="图片剪裁"
            :visible.sync="dialogVisible"
            append-to-body
          >
            <div class="cropper-content">
              <div class="cropper" style="text-align: center">
                <vueCropper
                  ref="cropper"
                  :img="option.img"
                  :outputSize="option.size"
                  :outputType="option.outputType"
                  :info="true"
                  :full="option.full"
                  :canMove="option.canMove"
                  :canMoveBox="option.canMoveBox"
                  :original="option.original"
                  :autoCrop="option.autoCrop"
                  :fixed="option.fixed"
                  :fixedNumber="option.fixedNumber"
                  :centerBox="option.centerBox"
                  :infoTrue="option.infoTrue"
                  :fixedBox="option.fixedBox"
                ></vueCropper>
              </div>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="finish" :loading="loading"
                >确认</el-button
              >
            </div>
          </el-dialog>
        </div>

        <dibu></dibu>
        <daohan></daohan>
      </div>
    </div>
  </div>
</template>

<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
var heightFlag = false; //全局变量
export default {
  components: {
    daohan,
    dibu,
    dingbu,
  },
  data() {
    return {
      bei_ing: this.Public.bei_ing,
      valueDate: '',
      obj_month: '',
      canClick: true,
      content: "获取验证码", // 按钮里显示的内容
      totalTime: 60, //记录具体倒计时时间
      nom: 0,
      addki: [
        {
          url: require("@/assets/img/jin_21.png"),
          text: "我的资料",
        },
        {
          url: require("@/assets/img/jin_20.png"),
          text: "课程列表",
        },
        {
          url: require("@/assets/img/jin_35.png"),
          text: "我的考试",
        },
        {
          url: require("@/assets/img/jin_19.png"),
          text: "考试记录",
        },
        {
          url: require("@/assets/img/jin_18.png"),
          text: "修改密码",
        }, {
          url: require("@/assets/img/jin_17.png"),
          text: "购买记录",
        }
      ],
      orderindex: 0,
      orderindexh: 0,
      cladk: false,
      recordo: [],
      usnamo: "",
      pawed: "",
      addkil: 1,
      pawedlg: "",
      pawedlk: "",
      ziliao: false,
      msg: "我的资料",
      adto: [
        {
          id: 2,
          text: "必修课程",
        },
        {
          id: 3,
          text: "选修课程",
        },
      ],
      addlik: [],
      usergo: [],
      sexto: "",
      id: "",
      elective: "",
      examine: [],
      examin: [],
      mlk: true,
      msgto: "",
      mtok: "",
      type: 2,
      phonet: "",
      codet: "",
      studtk: "",
      headimg: "//enterprise.t.brotop.cn/uploads/mo.png",
      // require("../../assets/upimg.png"),
      // 图片裁剪
      dialogVisible: false, // 裁剪组件的基础配置option
      option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 295, // 默认生成截图框宽度
        autoCropHeight: 413, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [5, 7], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      picsList: [], //页面显示的数组 // 防止重复提交
      loading: false,
      imgage: "",
      page: 1,
      pageNum: 6,
      total: 1,
      addtype: 1,
      options: [
        {
          value: "1",
          label: "男",
        },
        {
          value: "2",
          label: "女",
        },
      ],
      value: "1",
      text: "",
      typeid: "",
      stydeid: "",
      fabu: false,
      ke: false,
      kao: false,
      kaiv: false,
      xua: false,
    };
  },
  mounted() {
    // if (sessionStorage.getItem("ziliao") == 1) {
    //   document.documentElement.scrollTop = 120;
    //   this.ziliao = true;
    // this.$common.umdisabled()
    //   document.body.style.overflow = "hidden";
    //   document.addEventListener("touchmove", { passive: false }); // 禁止页面滑动
    // }
    // if (sessionStorage.getItem("kai") == 1) {
    //   this.orderindex = 2;
    //   document.documentElement.scrollTop = 30;
    //   this.kaiv = true;
    // this.$common.undisabled()
    //   document.body.style.overflow = "hidden";
    //   document.addEventListener("touchmove", { passive: false }); // 禁止页面滑动
    // }
    if (this.$route.query) {
      let query = this.$route.query
      if (query.orderindex) {
        this.orderindex = query.orderindex
        this.id = query.id
      } else {
        this.id = query.id
      }
    }

    this.getuser();
    this.getmyexam();
    this.getvideo_list(1);
    this.getexam_record();
    this.getindex();

  },
  created() {
    var aData = new Date();
    this.valueDate = aData.getFullYear() + "-" + (aData.getMonth() + 1);
    // console.log(this.valueDate)
    if (localStorage.getItem("ordindex")) {
      this.orderindex = localStorage.getItem("ordindex");
    }
    if (localStorage.getItem("ordertodo")) {
      this.orderindex = localStorage.getItem("ordertodo");
    }
    this.text = sessionStorage.getItem("text");
    this.typeid = sessionStorage.getItem("idto");
  },
  methods: {
    getpickerDate(e) {
      // console.log(e);
      this.obj_month = e.getFullYear() + "-" + (e.getMonth() + 1);
      this.getexam_record()
    },
    cartTatus(val) {
      // console.log(val);
      this.addlik = val.info
      this.total = val.total_num
    },
    Scroll(e) {
      // console.log(this.$refs.orderBox.scrollTop);
    },
    kaio() {
      sessionStorage.setItem("kai", 2);
      this.kaiv = false;
      this.$common.nodisabled()
      // document.body.style.overflow = ""; // 出现滚动条
      // document.removeEventListener("touchmove", { passive: false });
    },
    ziliaos() {
      this.ziliao = false;
      sessionStorage.setItem("ziliao", 2);
      // document.body.style.overflow = ""; // 出现滚动条
      // document.removeEventListener("touchmove", { passive: false });
      this.$common.nodisabled()
      document.documentElement.scrollTop = 300;
    },
    xuax() {
      this.xua = false;
      sessionStorage.setItem("xuanxiu", 2);
      this.$common.nodisabled()
      // document.body.style.overflow = ""; // 出现滚动条
      // document.removeEventListener("touchmove", { passive: false });
    },
    fabuyin() {
      document.documentElement.scrollTop = 0;
      this.fabu = false;
      sessionStorage.setItem("ziliao", 2);
      this.$common.nodisabled()
      // document.body.style.overflow = ""; // 出现滚动条
      // document.removeEventListener("touchmove", { passive: false });
    },
    kec() {
      let that = this;
      that.ke = false;
      sessionStorage.setItem("ziliao", 2);
      this.$common.nodisabled()
      // document.body.style.overflow = ""; // 出现滚动条
      // document.removeEventListener("touchmove", { passive: false });
      // this.kao = true;
    },
    kaos() {
      this.kao = false;
      sessionStorage.setItem("ziliao", 2);
      this.$common.nodisabled()
      // document.body.style.overflow = ""; // 出现滚动条
      // document.removeEventListener("touchmove", { passive: false });
    },
    paget(va) {
      this.addkil = 1;
    },
    addservere(val) {
      this.addtype = val;

      // console.log(val);
    },
    searchClick(value) {
      this.addlik = value.info;
      // console.log(this.addlik);
      this.total = value.total_num;
      for (var i = 0; i < this.addlik.length; i++) {
        if (this.addlik[i].is_major == 1) {
          this.addlik[i].elective = "必修";
        } else if (this.addlik[i].is_major == 2) {
          this.addlik[i].elective = "选修";
        }
      }
    },
    //验证 验证码
    animateWidth() {
      let that = this;
      var url = "lists/verify";
      let param = {
        mobile: this.phonet,
        code: this.codet,
      };
      this.post(url, param)
        .then((res) => {
          if (this.codet == "") {
            this.$message("请填写验证码");
          } else if (res.code == 0) {
            // this.$message(res.msg);
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    xuanke() {
      this.orderindex = 1;
    },
    //继续学习
    jixuxuexi(id) {
      this.$router.push({
        path: "/train",
        query: { id: this.id, gosid: id },
      });
    },

    //分页
    //上一页
    prev() {
      // console.log("eee");
      this.page = this.page - 1;
      this.getvideo_list();
      for (var i = 0; i < this.addlik.length; i++) {
        if (this.addlik[i].is_major == 1) {
          this.addlik[i].elective = "必修";
        } else if (this.addlik[i].is_major == 2) {
          this.addlik[i].elective = "选修";
        }
      }
    },
    //当前页
    next() {
      // console.log("eee");
      this.page = this.page + 1;
      // console.log(this.addtype);
      this.getvideo_list();
    },
    //搜索接口
    getsou() {
      let that = this;
      var url = "lists/sou";
      let param = {
        page: that.page,
        pageNum: that.pageNum,
        keyword: that.text,
        type: 3,
        id: that.typeid,
      };
      this.post(url, param)
        .then((res) => {
          this.addlik = res.data.info;
          for (var i = 0; i < this.addlik.length; i++) {
            if (this.addlik[i].is_major == 1) {
              this.addlik[i].elective = "必修";
            } else if (this.addlik[i].is_major == 2) {
              this.addlik[i].elective = "选修";
            }
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    //下一页
    current(e) {
      // console.log("e");
      this.addkil = e;
      this.page = e;
      // console.log(this.addtype);

      if (this.addtype == 1) {
        this.getvideo_list();
      } else {
        this.getsou();
        // console.log(this.text);
      }
    },
    getindex() {
      let that = this;
      var url = "user/index";
      let param = {};
      this.post(url)
        .then((res) => {
          this.usnamo = res.data.username;
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    // 图片裁剪
    // 上传按钮   限制图片大小
    // 上传按钮   限制图片大小
    changeUpload(file, fileList) {
      let that = this;
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 5MB!");
        return false;
      }
      this.fileinfo = file;

      // // 上传成功后将图片地址赋值给裁剪框显示图片
      // this.$nextTick(() => {
      //   // this.option.img = file.url;
      //   this.option.img =
      //     "http://kangaroo.qiniu.brotop.cn/uploads/20200729/a62515716a1662b21c2310ad27e6035e.png";
      //   this.dialogVisible = true;
      // });

      var formdata = new FormData();

      formdata.append("file", file.raw);
      // formdata.append("token", localStorage.getItem("token-qzb"));
      var url = "common/upload";

      that
        .post(url, formdata)
        .then(function (res) {
          let url = res.data.dai;
          that.option.img = url;
          that.dialogVisible = true;
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      let that = this;
      this.$refs.cropper.getCropData((data) => {
        // var fileName = "goods" + this.fileinfo.uid;
        var url = "common/upload_base64";
        var formdata = new FormData();

        formdata.append("base64_img", data);
        let param = {
          base64_img: data.data,
        };
        this.loading = true;

        that
          .post(url, formdata)
          .then(function (res) {
            // console.log(res.data);
            let url = res.data.priview_url;
            that.dialogVisible = false;
            that.headimg = url;
            that.image = res.data.url;

            // that.option.img = url;
            // that.dialogVisible = true;
          })
          .catch((err) => {
            // console.log(err);
          });
        //上传阿里云服务器
        // client()
        //   .put(fileName, data)
        //   .then((result) => {
        //     this.dialogVisible = false;
        //     this.picsList.push(result.url);
        //   })
        //   .catch((err) => {
        //     // console.log(err);
        //     this.loading = false;
        //   });
      });
    },

    //考试记录接口
    getexam_record() {
      let that = this, url = "exam/exam_record", param = {
        study_id: this.id,
        month: this.obj_month
      };
      that.post(url, param)
        .then((res) => {
          that.studtk = res.data;
          that.recordo = res.data.record;
          that.stydeid = res.data.id;
          for (var i = 0; i < that.recordo.length; i++) {
            if (that.recordo[i].is_pass == 1) {
              that.recordo[i].cladk = true;
            } else if (that.recordo[i].is_pass == 2) {
              that.recordo[i].cladk = false;
            }
          }
          that.recordo = that.recordo;

          that.$forceUpdate();
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    //获取验证码
    semat() {
      if (this.content == "获取验证码" || this.content == "重新发送验证码") {
        let that = this;
        var url = "lists/getcode";
        let param = {
          mobile: this.phonet,
        };
        this.post(url, param)
          .then((res) => {
            if (res.msg == "SUCCESS") {
              if (!this.canClick) return; //改动的是这两行代码
              this.canClick = false;
              this.content = this.totalTime + "s后重新发送";
              let clock = window.setInterval(() => {
                this.totalTime--;
                this.content = this.totalTime + "s后重新发送";
                if (this.totalTime < 0) {
                  window.clearInterval(clock);
                  this.content = "重新发送验证码";
                  this.totalTime = 60;
                  this.canClick = true; //这里重新开启
                }
              }, 1000);
              this.$message("发送成功");
            } else {
              this.$message(res.msg.msg);
            }
          })

          .catch((err) => {
            // console.log(err);
          });
      } else {
        return false;
      }
    },
    //修改密码
    xiugaipaw() {
      let that = this;
      var url = "lists/edit_pwd";
      let param = {
        username: this.usnamo,
        pwd: this.pawed,
        new_password: this.pawedlg,
        re_pwd: this.pawedlk,
      };
      this.post(url, param)
        .then((res) => {
          if (this.pawed == "") {
            this.$message("请输入原密码");
          } else if (this.pawedlg == "") {
            this.$message("请输入新密码");
          } else if (this.pawedlk == "") {
            this.$message("请再次输入新密码");
          } else if (this.pawedlk != this.pawedlg) {
            this.$message("您的两次密码不一致");
          } else if (res.code == 0) {
            // this.$message("您的密码不正确");
          } else if (res.code == 1) {
            this.$message("修改成功");
            this.orderindex = 1;
            this.msg = "我的资料";
            var mo = function (e) {
              e.preventDefault();
            };
            document.body.style.overflow = ""; //出现滚动条
            document.removeEventListener("touchmove", mo, false);
          }

          // console.log(res);
        })

        .catch((err) => {
          // console.log(err);
        });
    },
    //课程列表接口
    getvideo_list() {
      let that = this, url = "user/video_list", param = {
        id: this.id,
        type: this.type,
        pageNum: this.pageNum,
        page: this.page,
      };
      this.post(url, param)
        .then((res) => {
          this.addlik = res.data.info;
          for (var i = 0; i < this.addlik.length; i++) {
            if (this.addlik[i].is_major == 1) {
              this.addlik[i].elective = "必修";
            } else if (this.addlik[i].is_major == 2) {
              this.addlik[i].elective = "选修";
            }
          }
          this.addlik = this.addlik;
          this.total = res.data.total_num;
        })

        .catch((err) => {
          // console.log(err);
        });
    },
    //删除学习计划
    yichu(id) {
      // alert(id)
      //移除学习计划接口
      let that = this;
      var url = "user/del_join";
      let param = {
        id: id,
      };
      this.post(url, param)
        .then((res) => {
          return
          this.$message(res.msg);
          this.$router.go(0);
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    //修改资料
    baocunm() {
      let that = this;
      var url = "user/edit_info";
      let param = {
        id: this.id,
        nickname: this.usergo.nickname,
        sex: this.value,
        card: this.usergo.card,
        work_address: this.usergo.work_address,
        phone: this.phonet,
        code: this.codet,
        image: this.image,
      };
      if(param.sex == '男'){
        param.sex = 1
      }else if (param.sex == '女'){
        param.sex = 2
      }else{
        param.sex = 0
      }
      this.post(url, param)
        .then((res) => {
          // this.orderindex = 3;
          if (this.phonet == "") {
            this.$message("手机号不能为空");
          } else if (this.codet == "") {
            this.$message("验证码不能为空");
          } else if (res.code == 0) {
            this.$message("验证码错误");
          } else if (res.code == 1) {
            this.$message.success("保存成功")
            this.fabu = true;
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    //我的资料接口
    getuser() {
      let that = this;
      var url = "user/index";
      let param = {};
      this.post(url)
        .then((res) => {
          this.usergo = res.data;
          this.phonet = res.data.phone;
          // this.value = this.usergo.sex
          if (res.data.image != "") {
            this.headimg = res.data.image;
          }
          // console.log(this.usergo);
          if (this.usergo.sex == 1) {
            this.value = "男";
          } else if (this.usergo.sex == 0) {
            this.value = "女";
          }
          this.usergo = this.usergo;
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    //查看是否完善信息
    xianqing(id) {
      // 点击课程后直接跳转到视频页，由train.vue处理认证弹窗
      this.$router.push({
        path: "/train",
        query: { id: this.id, gosid: id },
      });
    },
    //我的考试接口
    getmyexam() {
      let that = this, url = "user/myexam", param = {
        id: that.id,
      };
      that.post(url, param)
        .then((res) => {
          that.examine = res.data.exam;
          that.examin = res.data.info;
          console.log(that.examine)
          console.log(that.examin)
          // console.log(that.examin);
          for (var i = 0; i < that.examine.length; i++) {
            that.examine[i]["num"] = that.examine[i].proportion;
            that.examine = that.examine;
          }
          // console.log(that.examine);
          for (var i = 0; i < that.examin.length; i++) {
            if (that.examin[i].status == 1) {
              that.examin[i].msgto = "学习中";
            } else if (that.examin[i].status == 2) {
              that.examin[i].msgto = "已完成 ";
            }
            that.examin = that.examin;
          }

          for (var i = 0; i < that.examin.length; i++) {
            that.examin[i]["nom"] = that.examin[i].proportion;

            if (that.examin[i].is_major == 1) {
              that.examin[i].mtok = "必修";
            } else if (that.examin[i].is_major == 2) {
              that.examin[i].mtok = "选修";
              that.examin[i].mlk = true;
            }
            that.examin = that.examin;
            // // console.log(that.examin);
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    //点击跳转到课程详情页
    todolist() {
      this.$router.push({ path: "/details" });
    },
    //侧边导航切换
    selorder(e) {
      let addt = this.addki;
      let that = this;
      for (var i = 0; i < addt.length; i++) {
        if (e.currentTarget.dataset.index == i) {
          that.msg = addt[i].text;
        }
      }
      that.orderindex = e.currentTarget.dataset.index;
      localStorage.setItem("ordindex", that.orderindex);

      let currentIndex = Number(that.orderindex)
      switch (currentIndex) {
        case 5:
          document.documentElement.scrollTop = 0;
          break;
        case 4:
          document.documentElement.scrollTop = 0;
          break;
        case 3:
          document.documentElement.scrollTop = 0;
          break;
        case 2:
          document.documentElement.scrollTop = 0;
          break;
        case 1:
          document.documentElement.scrollTop = 0;
          break;

        default:
          break;
      }

    },
    //课程导航切换
    selorderh(e) {
      this.orderindexh = e.currentTarget.dataset.index;
      if (e.target.dataset.id == 1) {
        this.type = 1;
        this.getvideo_list();
      }
      if (e.target.dataset.id == 2) {
        this.type = 2;
        this.getvideo_list();
      }
      if (e.target.dataset.id == 3) {
        this.type = 3;
        this.getvideo_list();
      }
    },
    //查看证书
    cha(id) {
      this.$router.push({
        path: "/certificate",
        query: { id: id, order: this.id },
      });
    },
    //点击跳转到考试须知
    kaishi() {
      this.$router.push({ path: "/exam", query: { id: this.id } });
    },
    //点击返回
    zhidoa() {
      this.orderindex = 0;
      this.msg = "我的资料";
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    //关闭修改密码
    guan() {
      this.orderindex = 3;
      this.msg = "考试记录";
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
  },
};
</script>
<style >
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #198bf8 !important;
  color: #fff;
  border-radius: 50%;
}
.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #ffffff;
  color: #06121e;
  min-width: 30px;
  border-radius: 2px;
}
.el-select {
  width: 72px;
}
.el-dialog {
  position: relative;
  margin: 0 auto 50px;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  width: 540px;
  height: 480px;
  background: #ffffff;
}
.el-button--default {
  width: 180px;
  height: 50px;
  background: #bdc4ce !important;
  border-radius: 25px;
}
.el-button--primary {
  width: 180px;
  height: 50px;
  background: #198bf8 !important;
  border-radius: 25px;
}
.el-dialog__body {
  padding: 30px 20px 0 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-upload-dragger {
  max-width: 155px;
  max-height: 155px;
  border: none;
}
</style>
<style scoped lang="less">
@import "../../css/profile.css";

.cropper-content .cropper {
  width: auto;
  height: 300px;
}

.purchase__history {
  width: 950px;
  background: #ffffff;
  padding: 28px 41px 54px 29px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin-left: 25px;

  .histoy {
    width: 100%;
    border: 1px solid #eee;
    box-sizing: border-box;

    .data_date {
      width: 100%;
      height: 40px;
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Regular;
      font-weight: 600;
      text-align: left;
      color: #06121e;
      line-height: 40px;
      padding: 0 24px;
      box-sizing: border-box;
      background-color: #eaeaea;
    }

    .store__box {
      width: 100%;
      display: flex;
      align-items: center;
      padding: 16px;
      box-sizing: border-box;

      img {
        width: 135px;
        height: 88px;
        border-radius: 8px;
      }

      .rig_box {
        flex: 1;
        padding-left: 16px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .big_title_money,
        .small_title_money,
        .down_text {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .big__title {
            flex: 1;
            font-size: 16px;
            font-family: Source Han Sans CN, Source Han Sans CN-Medium;
            font-weight: 600;
            text-align: left;
            color: #06121e;
          }
          .small__title {
            font-size: 14px;
            font-family: Source Han Sans CN, Source Han Sans CN-Regular;
            font-weight: 400;
            text-align: left;
            color: #707070;
          }

          .small__title {
            display: flex;
            align-items: center;
            height: 30px;

            img {
              width: 16px;
              height: 16px;
            }

            .start_time {
              font-size: 14px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: left;
              color: #06121e;
              margin-left: 8px;
            }
          }

          .kai__piao {
            width: 160px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            font-family: Source Han Sans CN, Source Han Sans CN-Medium;
            font-weight: 500;
            text-align: left;
            color: #3e8bff;
            height: 30px;
          }

          .big__money,
          .small__money {
            width: 160px;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .money_name {
              font-size: 14px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: left;
              color: #06121e;
            }
            .money_count {
              font-size: 14px;
              font-family: Source Han Sans CN, Source Han Sans CN-Medium;
              font-weight: 600;
              text-align: left;
              color: #ff1027;
            }

            .icon_money_name .icon_money_count {
              font-size: 14px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: left;
              color: #06121e;
              margin-right: 16px;
            }
          }
        }
      }
    }
  }
}
</style>